import { render, staticRenderFns } from "./Connectus.vue?vue&type=template&id=5bf1312b&scoped=true&"
import script from "./Connectus.vue?vue&type=script&lang=js&"
export * from "./Connectus.vue?vue&type=script&lang=js&"
import style0 from "./Connectus.vue?vue&type=style&index=0&id=5bf1312b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf1312b",
  null
  
)

export default component.exports